import React, { FC } from 'react';
import { logoAdAgency, logoPostProd, logoBroadcaster } from '../../assets/images';
import { UserRoleE } from '../../models/enums';

import styles from '../ProfilePhoto/profilePhoto.module.scss';
import { clss } from '../../utils/helpers/styleHelpers';

const LOGO_SIZE = 55;
const SCALE = .75;

type BroadcasterCanvasLogoPropTypes = {
    name?: string;
    size: any;
    role?: UserRoleE;
}

const DefaultLogo: FC<BroadcasterCanvasLogoPropTypes> = ({ name, size, role }) => {
    const getLogoFromUserRole = (role: UserRoleE) => {
        switch (role) {
            case UserRoleE.AdvertisingAgency: return logoAdAgency;
            case UserRoleE.PostProduction: return logoPostProd;
            case UserRoleE.Broadcaster: return logoBroadcaster;
            default: return logoAdAgency;
        }
    };

    return (
        <div className={clss([styles.defaultPhotoWrapper, styles?.[size]])}>
            <img src={getLogoFromUserRole(role)} alt="profile" />
        </div>
    );
};

export default DefaultLogo;